import { Clock } from 'lucide-react'

import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'

export const PostSkeleton = () => {
  return (
    <div className="mx-auto rounded-xl border p-4 opacity-50">
      <div className="mb-3 flex items-start justify-between">
        <div className="flex items-start gap-3">
          <Skeleton className="size-[45px] rounded-full" />
          <div>
            <div className="flex items-center gap-1.5">
              <Skeleton className="h-4 w-32" />
              <span className="text-muted">·</span>
              <Skeleton className="h-4 w-20" />
            </div>
            <div className="flex items-center text-sm text-muted">
              <Clock className="mr-1 size-3" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
        </div>
        <Skeleton className="size-8 rounded-full" />
      </div>

      <div className="space-y-3">
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-[85%]" />
        </div>

        <div className="flex items-center space-x-4 text-muted">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
        </div>
      </div>
    </div>
  )
}
